var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassengerUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48389 13.6224V12.8565C1.48389 9.89548 4.09007 7.49512 7.30495 7.49512C10.5198 7.49512 13.126 9.89548 13.126 12.8565V13.6224",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4629 9.02779C11.4629 6.91281 13.3245 5.19824 15.6208 5.19824C17.9171 5.19824 19.7787 6.91281 19.7787 9.02779V9.41074",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30484 7.49544C9.14188 7.49544 10.6312 6.12377 10.6312 4.4318C10.6312 2.7398 9.14188 1.36816 7.30484 1.36816C5.46776 1.36816 3.97852 2.7398 3.97852 4.4318C3.97852 6.12377 5.46776 7.49544 7.30484 7.49544Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6207 5.19751C16.9986 5.19751 18.1155 4.16878 18.1155 2.89978C18.1155 1.63078 16.9986 0.602051 15.6207 0.602051C14.2429 0.602051 13.126 1.63078 13.126 2.89978C13.126 4.16878 14.2429 5.19751 15.6207 5.19751Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassengerUsers);
export default __webpack_public_path__ + "static/media/passenger_users.fff24d8b.svg";
export { ForwardRef as ReactComponent };